'use strict';
const _=require('pulsar-utils/dist-es6/_');let

BaseTooltip=class BaseTooltip{
static get type(){
return'directive';
}

factory(){
let templateCount=[this.templateUrl,this.template].filter(t=>_.exists(t)).length;

if(templateCount>1){
throw new Error('cannot specify both "templateUrl" and "template"');
}

return{
restrict:'E',
templateUrl:this.templateUrl,
template:this.template,
link:{post:scope=>scope.$evalAsync()}};

}};


module.exports=BaseTooltip;
//# sourceMappingURL=baseTooltip.js.map
